export default __webpack_public_path__ + "static/nftx-d92d9a5c41db2b668fd9846c53d657c5.jpg";